import React, { useState, useRef } from "react";
import "./mobileProfile.css";
import { compactNumber } from "../../../functions/general";
// import fb from "../../../assets/images/social_Icons/facebook.svg";
// import insta from "../../../assets/images/social_Icons/instagram.svg";
// import twitter from "../../../assets/images/social_Icons/twitter.svg";
// import yt from "../../../assets/images/social_Icons/youtube.svg";
// import linkin from "../../../assets/images/social_Icons/linkedin.svg";

import pintrest from "../../../assets/images/pintrest.svg";
import linkedin from "../../../assets/images/linkedin.svg";
import facebook from "../../../assets/images/facebook.svg";
import twitter from "../../../assets/images/twitter.svg";
import youtube from "../../../assets/images/youtube.svg";
import insta from "../../../assets/images/insta.svg";
import dribble from "../../../assets/images/dribble.svg";
import behance from "../../../assets/images/behance.svg";
import Skeleton from "@material-ui/lab/Skeleton";
import { connect } from "react-redux";
import WmModals from "../../../modals/Wm.Modals";
import ClearIcon from "@material-ui/icons/Clear";
import { getFollowFollowingList, uploadPhoto, getUsersEntireData } from "../../../functions/apis";
import Cookies from "universal-cookie";
import Followlistcomponent from "../../../profilecard/Follow.list.component";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import loader from "../../../assets/images/I_loader.gif"
import { setMasterData } from "../../../services/actions/actions";
import { MAIN_URL } from "../../../config";
const cookies = new Cookies();

function MobileProfile({ rootData, setData }) {
  var token = cookies.get("wmtoken");
  const profile = useRef(null);
  const fileUpload = () => {
    profile.current.click();
  };
  const [isUploading, setIsUploading] = useState(false)
  const uploadPic = (e) => {
    setIsUploading(true)
    uploadPhoto(e.target.files[0])
      .then(function (res) {
        if (res.message === 'Profile Details Updated Successfully') {
          getUsersEntireData(rootData.user.username)
            .then(function (res) {
              setData(res)
              setIsUploading(false)
            })
            .catch(function (err) {
              setIsUploading(false)
              console.log(err)
            })
        }
      })
      .catch(function (err) {
        setIsUploading(false)
        console.log(err)
      })
  };
  const [followerModal, showFollowerModal] = useState(false);
  const [followingModal, showFollowingModal] = useState(false);
  const [followList, setFollowList] = useState([]);
  const [followingList, setFollowingList] = useState([]);
  const getFollowList = (action) => {
    if (token) {
      getFollowFollowingList(action)
        .then(function (res) {
          if (action === "FOLLOWER") {
            setFollowList(res);
          }
          if (action === "FOLLOWING") {
            setFollowingList(res);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    }
  };
  // loader rootData?.userProfilePic
  function isValidURL(string) {
    var res = string.match(/(http(s)?:\/\/.)/g);
    return (res !== null)
  };
  return (
    <React.Fragment>
      <div className="mobileProfilePic">
        <div className="mobileProfile px-6" id="timeLineProfile">
          {rootData?.userProfilePic ? (
            <>
              <div className='relative inline-block'>
                <input type="file" style={{ display: "none" }} accept="image/png, image/jpeg, image/jpg" ref={profile} onChange={(e) => uploadPic(e)} />
                <div className="h-20 w-20 bg-white rounded-full shadow">
                  <img src={isUploading ? loader : rootData?.userProfilePic} alt="profile" className="h-20 w-20 rounded-full border-white border-solid border-2" />
                </div>
                <div className="cursor-pointer edit_profile absolute w-8 h-8" style={{ right: '0' }}>
                  <PhotoCameraIcon className="cameraIcon" onClick={fileUpload} />
                </div>
              </div>
            </>
          ) : (
            <React.Fragment>
              <Skeleton
                variant="circle"
                className="mb-4"
                height={90}
                width={90}
              />
            </React.Fragment>
          )}
        </div>
        <div className="profileDescription text-center">
        <span className='block text-base' style={{color:'var(--color-5)'}}>{`${rootData.userData.profile_data?.fname} ${rootData.userData.profile_data?.lname}`}</span>
          <a
            href={`${MAIN_URL}${rootData.user.username}`}
            className="manpro block text-gray-700 text-sm"
          >
            {rootData.user.username && `@${rootData.user.username}`}
          </a>
          {rootData.userData.isInstitute ? '' : <p
            className=" mb-1 text-xs text-gray-700 px-8 leading-5 manpro"
            style={{ color: "#858585" }}
          >
            {rootData.bio && rootData.bio}
          </p>}
        </div>
        <div className="profile_social_icon_wrapper flex space-x-5 mt-6 items-center justify-center">
          {rootData.fb && (
            <a href={`${isValidURL(rootData.fb) ? rootData.fb : `https://www.facebook.com/${rootData.fb.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
              <img src={facebook} alt="icons" className="w-2.5" style={{filter:'invert(1)'}}/>
            </a>
          )}
          {rootData.linkdin && (
            <a href={`${isValidURL(rootData.linkdin) ? rootData.linkdin : `https://www.linkedin.com/in/${rootData.linkdin.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
              <img src={linkedin} alt="icons" className="w-5" style={{filter:'invert(1)'}}/>
            </a>
          )}
          {rootData.insta && (
            <a href={`${isValidURL(rootData.insta) ? rootData.insta : `https://www.instagram.com/${rootData.insta.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
              <img src={insta} alt="icons" className="w-5" style={{filter:'invert(1)'}}/>
            </a>
          )}
          {rootData.youtube && (
            <a href={`${isValidURL(rootData.youtube) ? rootData.youtube : `https://www.youtube.com/c/${rootData.youtube.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
              <img src={youtube} alt="icons" className="w-5" style={{filter:'invert(1)'}}/>
            </a>
          )}
          {rootData.behance && (
            <a href={`${isValidURL(rootData.behance) ? rootData.behance : `https://www.behance.net/${rootData.behance.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
              <img src={behance} alt="icons" className="w-5" style={{filter:'invert(1)'}}/>
            </a>
          )}
          {rootData.pintrest && (
            <a href={`${isValidURL(rootData.pintrest) ? rootData.pintrest : `https://in.pinterest.com/${rootData.pintrest.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
              <img src={pintrest} alt="icons" className="w-5" style={{filter:'invert(1)'}}/>
            </a>
          )}
          {rootData.dribble && (
            <a href={`${isValidURL(rootData.dribble) ? rootData.dribble : `https://dribbble.com/${rootData.dribble.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
              <img src={dribble} alt="icons" className="w-5" style={{filter:'invert(1)'}}/>
            </a>
          )}
          {rootData.twitter && (
            <a href={rootData.twitter} href={`${isValidURL(rootData.twitter) ? rootData.twitter : `https://twitter.com/${rootData.twitter.replace(/[/|&;$%@"<>()+,]/g, '')}`}`} target="_blank">
              <img src={twitter} alt="icons" className="w-5" style={{filter:'invert(1)'}}/>
            </a>
          )}
        </div>
        <div
          className="follow-status mx-auto justify-between mt-6 grid grid-cols-3"
        >
          <div className="follow-count text-center leading-3 text-gray-700" onClick={() => {
            showFollowerModal(true);
            getFollowList("FOLLOWER");
          }}>
            <h3 className="font-semibold text-xl manpro text-gray-700 mb-0">
              {rootData.userData?.follower_count
                ? compactNumber(rootData.userData?.follower_count)
                : 0}
            </h3>
            <p className="mb-0 text-sm  manpro">
              {rootData.userData?.follower_count > 0 ? "Follower" : "Followers"}
            </p>
          </div>
          <div
            className="following-count text-center leading-3 text-gray-700"
            onClick={() => {
              showFollowingModal(true);
              getFollowList("FOLLOWING");
            }}
          >
            <h3 className=" font-semibold text-xl manpro text-gray-700 mb-0">
              {rootData.userData?.following_count
                ? compactNumber(rootData.userData?.following_count)
                : 0}
            </h3>
            <p className="mb-0 text-sm  manpro">Following</p>
          </div>
          <div className="posts-count text-center leading-3 text-gray-700">
            <h3 className="font-semibold text-xl manpro mb-0">
              {rootData?.postCount
                ? compactNumber(JSON.parse(rootData?.postCount))
                : 0}
            </h3>
            <p className=" mb-0 text-sm  manpro">
              {rootData?.postCount > 0 ? "Post" : "Posts"}
            </p>
          </div>
        </div>
      </div>

      <WmModals
        show={followerModal}
        onHide={() => showFollowerModal(false)}
        size="lg"
        className="edu-modal"
      >
        <h4 className="manpro font-semibold text-2xl">
          {rootData.userData?.follower_count > 0 ? "Follower" : "Followers"}
        </h4>
        <ClearIcon
          className="cancel absolute cursor-pointer"
          onClick={() => showFollowerModal(false)}
        />
        {followList.length <= 0 ? (
          <div className="text-center">
            <span className="manpro font-semibold">No Followers Found</span>
          </div>
        ) : (
          followList.map((followList, idx) => {
            return (
              <Followlistcomponent
                key={idx}
                followData={followList}
                hideModal={() => showFollowerModal(false)}
                view="FOLLOWERS"
              />
            );
          })
        )}
      </WmModals>
      <WmModals
        show={followingModal}
        onHide={() => showFollowingModal(false)}
        size="lg"
        className="edu-modal"
      >
        <h4 className="manpro font-semibold text-2xl">Following</h4>
        <ClearIcon
          className="cancel absolute cursor-pointer"
          onClick={() => showFollowingModal(false)}
        />
        {followingList.length <= 0 ? (
          <div className="text-center">
            <span className="manpro font-semibold">No Followings Found</span>
          </div>
        ) : (
          followingList.map((followingList, idx) => {
            return (
              <Followlistcomponent
                key={idx}
                followData={followingList}
                hideModal={() => showFollowerModal(false)}
                view="FOLLOWING"
              />
            );
          })
        )}
      </WmModals>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToState = (dispatch) => {
  return {
    setData: (value) => {
      dispatch(setMasterData(value));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToState)(MobileProfile);
